module.exports = __webpack_public_path__ + "static/media/dash-client.ccf33ac5.svg";